import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';

export function getFirstMatch(regex: RegExp, text: string) {
  return text.match(regex)?.[1];
}

// 중요! server/clientShared.ts 에 있는 compareVersions 함수와 항상 같도록 관리하자
export function compareVersions({
  lower,
  higher,
}: {
  lower: string;
  higher: string;
}) {
  const lowers = lower.split('.').map(Number);
  const highers = higher.split('.').map(Number);
  while (lowers.length !== highers.length) {
    if (lowers.length > highers.length) {
      highers.push(0);
    } else {
      lowers.push(0);
    }
  }
  let i = 0;
  while (lowers.length > i && highers.length > i) {
    if (lowers[i] > highers[i]) {
      return false;
    } else if (lowers[i] < highers[i]) {
      return true;
    }
    i++;
  }

  return false;
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
function escapeRegExp(str: string) {
  return str.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
}

export function decorateText({
  text,
  matchStr,
  decorator,
  isIgnoreCase = true,
}: {
  text: string;
  matchStr: string;
  decorator: (matched: string) => string;
  isIgnoreCase?: boolean;
}): string {
  const matcher = new RegExp(
    `(${escapeRegExp(matchStr)})`,
    isIgnoreCase ? 'i' : ''
  );
  const matchArr = text.split(matcher);
  matchArr.forEach((part, index) => {
    matchArr[index] = part.match(matcher) ? decorator(part) : part;
  });
  return matchArr.join('');
}

export function filteredJoin(
  strArray: Array<string | undefined>,
  separator: string
) {
  return strArray.filter(Boolean).join(separator);
}

export function toCamelCase(str?: string) {
  return camelCase(str);
}

export function toSnakeCase(str?: string) {
  return snakeCase(str);
}

export function toConstantCase(str?: string) {
  return snakeCase(str).toUpperCase();
}

export function convertHexToRgb(h?: string) {
  if (h?.includes('#') && (h.length === 4 || h.length === 7)) {
    let r: number;
    let g: number;
    let b: number;
    if (h.length === 4) {
      r = parseInt(`${h[1]}${h[1]}`, 16);
      g = parseInt(`${h[2]}${h[2]}`, 16);
      b = parseInt(`${h[3]}${h[3]}`, 16);
    } else {
      r = parseInt(`${h[1]}${h[2]}`, 16);
      g = parseInt(`${h[3]}${h[4]}`, 16);
      b = parseInt(`${h[5]}${h[6]}`, 16);
    }
    return `${r}, ${g}, ${b}`;
  } else {
    return '0, 0, 0';
  }
}
